import { useQuery } from "urql";

import { GetInsuranceSlaDocument } from "../../../graphql/generated.ts";

export const useInsuranceSla = () => {
  return useQuery({
    query: GetInsuranceSlaDocument,
  });
};
